import { useEffect, useState } from 'react';
import { usePlaystationPreview } from './usePlaystationPreview';
import { useTizenPreview } from './useTizenPreview';
import { useSearchParams } from 'react-router-dom';
import { useAppFeaturesContext } from '../../contexts/AppFeaturesContext/AppFeaturesContext';
import { LAUNCHER_REDIRECT } from '../../constants';
import { getUtmParameters } from '../../analytics/analytics-utils';
import { idFromUri } from '../../utils/pointer';

const useDeviceRedirects = () => {
  const { mode } = useAppFeaturesContext();

  const [deeplink, setDeeplink] = useState<string | null>(null);

  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (deeplink === null || !deeplink.length) return;

    const id = idFromUri(deeplink.replace('/player', ''));
    const isPlayerUri = !!deeplink?.includes('/player');

    setSearchParams(prev => {
      prev.set(
        LAUNCHER_REDIRECT,
        deeplink.concat(
          `?${new URLSearchParams(getUtmParameters(mode, isPlayerUri, id)).toString()}`
        )
      );
      return prev;
    });

    setDeeplink(null);
  }, [deeplink, mode, setSearchParams]);

  useTizenPreview(mode, setDeeplink);
  usePlaystationPreview(mode, setDeeplink);

  return {
    setPreviewRedirect: setDeeplink,
  };
};

export default useDeviceRedirects;
